import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { FileInfo, FileStatus } from '../UploaderTypes'
import { Icons } from '@/icons/icons'
import { useI18n } from 'vue-i18n-composable'
import { vars } from '@/styles/styleVars'
import DocumentIconComponent from './DocumentIconComponent.vue'
import { formatBytes } from '@/helpers/file'

// DEFINE PROPS  ======================================================================================================

export default /*#__PURE__*/_defineComponent({
  __name: 'FileLoadingComponent',
  props: {
  file: {
    type: Object as PropType<FileInfo>,
    required: true
  }
},
  setup(__props) {

const props = __props;


// TRANSLATIONS
const { t } = useI18n()

const backgroundColors = {
  [FileStatus.LOADED]: vars.progress_bar_success,
  [FileStatus.ERROR]: vars.progress_bar_error,
  [FileStatus.LOADING]: vars.progress_bar_default_color
}

const texts = {
  error: t('components.progress_bar.error'),
  errorText: t('components.progress_bar.error_text'),
  loadingText: t('components.progress_bar.executing'),
  successText: t('components.progress_bar.completed')
}

const status = {
  [FileStatus.LOADED]: texts.successText,
  [FileStatus.ERROR]: texts.error,
  [FileStatus.LOADING]: texts.loadingText
}

const iconStatus = {
  [FileStatus.LOADED]: Icons.CHECK_ROUND_FULL,
  [FileStatus.LOADING]: Icons.SPINNER,
  [FileStatus.ERROR]: Icons.CLOSE_ROUND_FULL
}

// COMPUTEDS ==========================================================================================================
const computedInfoIcon = computed(() => iconStatus[props.file.status as keyof typeof iconStatus])
const infoText = computed(() => status[props.file.status as keyof typeof status])
const backgroundColor = computed(() => backgroundColors[props.file.status as keyof typeof backgroundColors])
const indeterminate = computed(() => props.file.status === FileStatus.LOADING)
const showError = computed(() => props.file.status === FileStatus.ERROR)
const fileSize = computed(() => props.file.file?.size && formatBytes(props.file.file?.size || 0))

return { __sfc: true,props, t, backgroundColors, texts, status, iconStatus, computedInfoIcon, infoText, backgroundColor, indeterminate, showError, fileSize, vars, DocumentIconComponent }
}

})